import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-empty-page',
    templateUrl: './empty-page.component.html',
    styleUrls: ['./empty-page.component.scss'],
    standalone: false
})
export class EmptyPageComponent implements OnInit {
  @Input() img!: string;
  @Input() type!: string;
  @Input() header!: string;
  @Input() description!: string;
  @Input() buttonText!: string;
  @Output() onClickButton: EventEmitter<boolean> = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  buttonClicked() {
    this.onClickButton.emit(true);
  }
}
